import "./style.css";

export const Tabs = ({
  name,
  activeTab,
  handleTabClick,
  value,
}: {
  value: string;
  name: string;
  activeTab: string;
  handleTabClick: (tab: string) => void;
}) => {
  return (
    <button
      aria-label={name}
      className={`py-2 px-2 rounded-lg w-40 ${activeTab === value ? "bg-blues-navy text-white" : "text-gray-700"}`}
      onClick={() => handleTabClick(value)}
      data-track={`tab-button-${value}`}
    >
      {name}
    </button>
  );
};

export const TabContent = ({
  title,
  data,
  onClick,
  showBtn,
  isSelected,
}: {
  showBtn: boolean;
  title: string;
  data: any;
  onClick?: () => void;
  isSelected: boolean;
}) => {
  return (
    <div key={`feature-compare-${data.feature_id}`} className="tab-content">
      <h3 className="text-xl font-bold mb-6">{title}</h3>
      {data.map((feature: any, index: number) => (
        <div key={`tab-data-item-${title}-${index}`} className="flex flex-col">
          <span className="title text-blues-ink">{feature.feature_name}</span>
          <span
            className="description text-grey-scale-slate"
            dangerouslySetInnerHTML={{ __html: feature.feature_description }}
          />
        </div>
      ))}
      {showBtn && (
        <button
          aria-label="Subscribe Now"
          onClick={onClick}
          className="subscribe-btn !w-full"
          data-track={`subscribe-button-${title}`}
        >
          {isSelected ? "Currently Selected" : "Subscribe Now"}
        </button>
      )}
    </div>
  );
};
